import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';
import hexToRGB from '../../helpers/hexToRgb';
import styled from 'styled-components';

type Props = {
  maxHeight?: number;
  shouldLimitHeight: boolean;
};

export const ShowMore = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.TEXT_ALIGNMENT_LEFT)};
  ${({ theme }) => theme.ui.links.fontColor !== '' && `color: ${theme.ui.links.fontColor};`};
  text-decoration: underline;
`;

export const ShowLess = styled(ShowMore)``;

export const Text = styled.div<Props>`
  color: ${({ theme }) => theme.ui.text.color};
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.typography.size.medium};
  line-height: 1.25;
  overflow: auto;
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight}px` : '')};
  padding: ${({ theme }) => theme.spacing.base.xxs} 0;

  ${media.ie11} {
    /* IE10+ CSS styles go here */
    ${({ shouldLimitHeight }) => (shouldLimitHeight ? `max-height: 60px` : '')};
  }

  ${({ theme }) =>
    theme.ui.links.fontColor !== '' &&
    `a {
   color: ${theme.ui.links.fontColor};
 }`}
`;

type FaderProps = {
  faderHeight: number;
  textHeight: number;
};

export const FadeScrollerTop = styled.div<FaderProps>`
  content: '';
  display: block;
  height: ${({ faderHeight }): number => faderHeight}px;
  pointer-events: none;

  z-index: 10;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${hexToRGB(theme.ui.layer.backgroundColor, 1)} 0%, ${hexToRGB(
      theme.ui.layer.backgroundColor,
      0,
    )} 100%)`};
  margin-top: -${({ textHeight }): number => textHeight + 1}px;
`;

export const FadeScrollerBottom = styled.div<FaderProps>`
  content: '';
  display: block;
  height: ${({ faderHeight }): number => faderHeight}px;
  pointer-events: none;

  z-index: 10;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${hexToRGB(theme.ui.layer.backgroundColor, 0)} 0%, ${hexToRGB(
      theme.ui.layer.backgroundColor,
      1,
    )}100%)`};
  margin-top: ${({ faderHeight, textHeight }): number => textHeight + 2 - faderHeight * 2}px;
`;
